document.addEventListener("DOMContentLoaded", () => {
  const navItems = document.querySelectorAll(".holiday-nav-item"); // 所有导航项
  const modules = document.querySelectorAll(".holiday-section"); // 所有模块
  const navContainer = document.querySelector(".holiday-nav-mb-box"); // 导航容器
  const targetHideElement = document.querySelector(".holiday-nav-mb"); // 隐藏导航的区域

  navItems.forEach((item) => {
    item.addEventListener("click", () => {
      const targetId = item.getAttribute("data-target");
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        // 1. 用 history.replaceState 更新地址栏哈希，不触发默认滚动
        history.replaceState(null, null, `#${targetId}`);

        // 2. 仅执行你的自定义滚动逻辑（不受哈希影响）
        window.scrollTo({
          top: targetElement.offsetTop - 80,
          behavior: "auto", // 保持你的自定义滚动行为
        });
      }
    });
  });

  // 监听页面滚动事件
  window.addEventListener("scroll", function () {
    // 1. 隐藏导航逻辑：滚动到 targetHideElement 以上区域时隐藏
    if (targetHideElement) {
      // 避免元素不存在时报错
      const targetHideRect = targetHideElement.getBoundingClientRect();
      // 当 targetHideElement 的顶部 <= 0 时，说明元素已进入视口（滚动到其以上区域）
      const isAboveTargetArea = targetHideRect.top <= 0;
      if (isAboveTargetArea) {
        navContainer.classList.add("active");
      } else {
        navContainer.classList.remove("active");
      }
    }

    const scrollPosition = window.scrollY + 100; // 偏移量

    modules.forEach((module) => {
      const moduleId = module.id; // 当前模块ID（如module1）
      const moduleTop = module.offsetTop;
      const moduleHeight = module.offsetHeight;

      // 检查当前滚动位置是否在该模块范围内
      if (
        scrollPosition >= moduleTop &&
        scrollPosition < moduleTop + moduleHeight
      ) {
        // 找到data-target等于当前模块ID的导航项
        navItems.forEach((item) => {
          if (item.getAttribute("data-target") === moduleId) {
            item.classList.add("active");
          } else {
            item.classList.remove("active");
          }
        });
      }
    });
  });

  // 初始化触发一次滚动事件，设置初始状态
  window.dispatchEvent(new Event("scroll"));

  var bestSaleSwiper = new Swiper(".best-sale-list", {
    slidesPerView: 4,
    grid: {
      rows: 1,
    },
    spaceBetween: 28,
    breakpoints: {
      // 769px以上
      1000: {
        slidesPerView: 4,
        grid: {
          rows: 1,
        },
        spaceBetween: 28,
      },
      769: {
        slidesPerView: 3,
        grid: {
          rows: 1,
        },
        spaceBetween: 15,
      },
      0: {
        slidesPerView: 2,
        grid: {
          rows: 2,
        },
        spaceBetween: 15,
      },
    },
    pagination: {
      el: ".best-sale-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".best-sale-next",
      prevEl: ".best-sale--prev",
    },
  });

  const navList = document.querySelectorAll(".nav-pro-item");
  const saleList = document.querySelectorAll(".flash-sale-list");

  navList.forEach((nav) => {
    nav.addEventListener("click", function () {
      const text = nav.textContent.trim();

      navList.forEach((item) => {
        item.classList.remove("active");
      });

      nav.classList.add("active");

      saleList.forEach((list) => {
        const value = list.getAttribute("value").trim();
        list.classList.remove("active");

        if (text == value) {
          list.classList.add("active");
        }
      });
    });
  });


  // klaviyo 邮箱弹窗
  const windowBtns = $('.close-window-btn')
  windowBtns.click(function() {
    const $this = $(this)
    $this.parents('.klaviyo-window-box').removeClass('active')
  })


  const notifyBtns = $('.notify-btn')
  notifyBtns.click(function() {
    const $this = $(this)
    const parent = $this.parents('.section-notify')
    parent.find('.klaviyo-window-box').addClass('active')
  })



  // 下雪效果
  const snowContainer = document.getElementById("snow-container");
  // 雪花数量：移动端40，桌面端100
  const snowflakeCount = window.innerWidth < 768 ? 40 : 100;

  function createSnowflakes() {
    snowContainer.innerHTML = "";

    for (let i = 0; i < snowflakeCount; i++) {
      const snowflake = document.createElement("div");
      const size = Math.random() * 2 + 1; // 小雪花（1-3px），避免稀疏感
      const icon = "●";

      snowflake.innerHTML = icon;
      snowflake.classList.add("snowflake");
      snowflake.style.fontSize = `${size * 3}px`;
      snowflake.style.left = `${Math.random() * 100}vw`;
      snowflake.dataset.opacity = Math.random() * 0.6 + 0.4; // 稍高透明度，弱化稀疏感

      // 核心1：初始位置覆盖「-100vh到100vh」（顶部外1屏到页面底部）
      // 页面加载时，既有刚飘入的，也有在中间/底部的雪花，瞬间填满画面
      snowflake.style.top = `${Math.random() * 200 - 100}vh`;

      snowContainer.appendChild(snowflake);
      animateSnowflake(snowflake); // 无初始延迟，立即启动
    }
  }

  function animateSnowflake(snowflake) {
    snowflake.style.opacity = snowflake.dataset.opacity;
    const size = parseFloat(snowflake.style.fontSize);

    // 核心2：超慢速度（40-80秒），飘落极缓
    const duration = Math.random() * 20 + 20;
    // 漂移量随速度放缓（慢雪花漂移更轻柔）
    const drift = (Math.random() - 0.5) * (duration * 1.5);

    // 随机水平位置，避免重复轨迹
    snowflake.style.left = `${Math.random() * 100}vw`;
    snowflake.style.transform = "translateX(0)";

    // 漂移动画（缓慢左右摇摆）
    snowflake.animate(
      [{ transform: `translateX(0)` }, { transform: `translateX(${drift}px)` }],
      {
        duration: duration * 1000,
        iterations: 1,
        easing: "cubic-bezier(0.1, 1, 0.9, 1)",
      }
    );

    // 下落动画（从当前位置到页面外20%，确保完全离开）
    const fallAnim = snowflake.animate(
      [{ top: snowflake.style.top }, { top: `120vh` }],
      { duration: duration * 1000, iterations: 1, easing: "linear" }
    );

    // 核心3：提前1秒重置，在雪花即将落地时就重生，彻底无间隔
    const resetTime = duration * 1000 - 2000; // 总时长减1秒
    setTimeout(() => {
      // 重置到顶部外随机位置（-100vh到0vh），新雪花提前进入视野
      snowflake.style.top = `${Math.random() * 100 - 100}vh`;
      snowflake.getBoundingClientRect(); // 强制样式生效
      animateSnowflake(snowflake);
    }, resetTime);
  }

  // 滚动动画保持不变
  function handleScrollAnimation() {
    const sections = document.querySelectorAll(".section-fade");
    sections.forEach((section) => {
      const sectionTop = section.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;
      if (sectionTop < windowHeight * 0.85) {
        section.classList.add("section-visible");
      }
    });
  }

  // 初始化
  createSnowflakes();
  handleScrollAnimation();

  window.addEventListener("resize", createSnowflakes);
  window.addEventListener("scroll", handleScrollAnimation);
});
